import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { APP_PATHS, SEARCH_INSTALLATIONS_TABLE_COLUMNS_CONFIG } from '@core/constants';
import { addressLine } from '@core/helpers/address.helper';
import { SearchInstallationModel } from '@core/models';
import { TableComponent } from '@custom-components/general/table/table.component';

@Component({
  selector: 'xemex-installations-content',
  imports: [TableComponent],
  templateUrl: './installations-content.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InstallationsContentComponent {
  installations = input<SearchInstallationModel[]>([]);
  loading = input(false);

  protected readonly columns = SEARCH_INSTALLATIONS_TABLE_COLUMNS_CONFIG;

  protected readonly tableData = computed(() =>
    this.installations().map(installation => ({
      ...installation,
      address: addressLine({
        street: installation.locationStreet,
        streetNumber: installation.locationStreetNumber,
        streetNumberAddition: installation.locationStreetNumberAddition,
        postalCode: installation.locationPostalcode,
        city: installation.locationCity,
      }),
      partnerName: installation.partnerName ?? '',
    })),
  );

  protected readonly rowLink = (row: Record<string, unknown>) => [
    '/',
    APP_PATHS.Installations,
    `${row['installationOid']}`,
    'general',
  ];
}
